import React from "react";
import { Navigate } from "react-router-dom";
import {
  getCustomerToken,
  getCustomerAgencyURL,
} from "../components/common/CommonFunctions";
import { ROOT_ADMIN, ROOT_EMPLOYEE } from "../constants/HelperConstants";
import {
  CUSTOMER_STATE,
  CUSTOMER_TOKEN,
  CUSTOMER_USERNAME,
  PAY_PUP_LS_AUTH_TOKEN,
  PAY_PUP_LS_AUTH_USER_ROLE,
} from "../constants/LocalStorageVariables";
import {
 
  SIGNIN_ROUTE,
  USER_SIGNIN,
  USER_DASHBOARD,
} from "../constants/RoutePaths";
export default function PublicRoute({ children }) {
  const token = localStorage.getItem(PAY_PUP_LS_AUTH_TOKEN);
  const isRoot = [ROOT_ADMIN, ROOT_EMPLOYEE].includes(authUserRole());
  return !token ? (
    children
  ) : isRoot ? (
    <Navigate to="/admin/dashboard" replace/>
  ) : (
    <Navigate to="/agency/dashboard" replace/>
  );
}
export function AgencyPrivateRoute({ children }) {
  const token = localStorage.getItem(PAY_PUP_LS_AUTH_TOKEN);
  const agencyname = window.location.href
    .split(window.location.host)[1]
    .split("/")[2];
  if (token && (localStorage.getItem('PAY_PUP_AGENCY_URL') == agencyname)) {
    return children;
  } else {
     return <Navigate to={"/signin"} />;
  }
}
export function PrivateRoute({ children }) {
  const token = localStorage.getItem(PAY_PUP_LS_AUTH_TOKEN);
  return token ? children : <Navigate to={"/signin"} />;
}
export function CustomerPublicRoute({ children }) {
  const token = getCustomerToken();

  return !token ? children : <Navigate to={USER_DASHBOARD} />;
}
export function CustomerPrivateRoute({ children }) {
  const token = getCustomerToken();
  return !token ? children : <Navigate to={USER_SIGNIN} />;
}

export function UrlCustomerPrivateRoute({ children }) {
  const token = getCustomerToken();
  const agencyname = window.location.href
    .split(window.location.host)[1]
    .split("/")[2];
  //localhost:3000/customer/view-license/302/new-york-pet-association  ?dogLicenseId
  return token?children:<Navigate to={USER_SIGNIN+"/"+agencyname}/>
  
}
export function authHeader() {
  const token = localStorage.getItem(PAY_PUP_LS_AUTH_TOKEN);
  return { Authorization: token };
}

export function authCustomerHeader() {
  const customertoken = localStorage.getItem(CUSTOMER_TOKEN);
  return { Authorization: customertoken };
}

export function customerName() {
  const name = localStorage.getItem(CUSTOMER_USERNAME);
  return name;
}
export function customerState() {
  const state = localStorage.getItem(CUSTOMER_STATE);
  return state;
}

export const authUserRole = () => {
  const Role = localStorage.getItem(PAY_PUP_LS_AUTH_USER_ROLE);
  return Role;
};

export const getAlertToast = (type = "success", text = "", timer = 5000) => ({
  toast: true,
  position: "bottom",
  titleText: text,
  type: type,
  showConfirmButton: false,
  timer: timer,
});

export const getAlert = (type = "success", text = "") => ({
  position: "center",
  type: type,
  text: text,
  customClass: {
    confirmButton: "btn-shadow btn btn-primary btn-lg",
  },
  buttonsStyling: false,
  confirmButtonColor: "#000",
});

//Auth Logout
export function logout(history) {
  localStorage.clear();
  history(SIGNIN_ROUTE);
}
export function Userlogout(history) {
  const Url = getCustomerAgencyURL();
  localStorage.clear();
  history("/customer/" + Url);
}

export const locationParams = (search) => {
  const searchParams = new URLSearchParams(search);
  const ob = {};
  searchParams.forEach(function (value, key) {
    ob[key] = value;
  });
  return ob;
};
